import React, { useContext, useEffect, useState } from "react";
import { Box } from "@mui/system";

import moment from "moment";
import styled from "styled-components";
import { PricingCalendarV2 } from "components/V2/organisms/PricingCalendarV2/PricingCalendarV2";
import { BookingDataContext } from "../../../../context/BookingDataContext";
import { setSelectedJourneys } from "@/store/slices/checkIn";
import { CommonDataContext } from "../../../../context/CommonDataContext";
import { extractResource } from "../../../../helper/extractResource";
import CustomSwitch from "../../../CustomSwitch/CustomSwitch";
import { JourneyDetails } from "../CheckinBookingTypes";
import { CheckinJourneySelectionCard } from "../CheckinJourneySelectionCard";
import cssStyle from "../checkIn.module.css";
import { useDispatch } from "react-redux";

const label = { inputProps: { "aria-label": "Switch demo" } };

const FCal = styled.div`
display:flex;
flex-direction:row;
justify-content:space-between;
align-items:center;
margin:0.5rem;
margin-left:0;
margin-right:0;
padding-left:0.5rem;
padding-right:0.5rem;
height: fit-content;
padding-top:0.5rem
background: #FFFFFF;
box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
border-radius: 4px;
`;

function Calendar({ ...props }) {
  const dispatch = useDispatch();
  const { airports, selectedCurrency } = useContext(CommonDataContext);
  const { origin, setOrigin, destination, setDestination, departureDate } = useContext(BookingDataContext);
  const { resourceData } = props;
  const passengerSegment = props.passengerSegments;
  const [card, setCard] = useState(props.journeys);
  const [disabled, setDisabled] = useState(false);
  const [firstJourneyDate, setFirstJourneyDate] = useState<Date>(() => new Date(card[0]?.journeyDetails?.designator?.departure))
  const [secondJourneyDate, setSecondJourneyDate] = useState<Date>(() => new Date(card[1]?.journeyDetails?.designator?.departure))

  let selectedJourneys = !props?.isChangeBooking ? props.journeys : [];

  function isAnyPaxUnchecked(journeyDetails: any): boolean {
    return journeyDetails.segments[0].passengerSegment
      .some((passenger: any) => passenger.liftStatus !== "CheckedIn")
  }

  const toggle = (e) => {
    const { name, checked } = e.target;
    if (name === "allSelect") {
      selectedJourneys = card.map((ele, index) => {
        if (moment(ele.journeyDetails.designator.departure) > moment()) {
          // when flight is more then today
          if(!isAnyPaxUnchecked(ele.journeyDetails)) {
            return { ...ele, isChecked: false };
          } if (ele?.data?.checkinByJourneyRequirements?.restrictions !== "NotOpened") {
            return { ...ele, isChecked: checked };
          } 
            setDisabled(false);
          
        }
        return { ...ele, isChecked: false }; // when flight is less than today
      });
      setCard(selectedJourneys);
    } else {
      if (name == 0) {
        if (card["1"]?.data?.checkinByJourneyRequirements?.restrictions !== "NotOpened") {
          card[name]?.isChecked == true ? setDisabled(false) : setDisabled(true);
        }
        selectedJourneys = card.map((ele, id) =>
          id == name
            ? { ...ele, isChecked: checked }
            : ele && id == 1 && !props?.isChangeBooking
            ? { ...ele, isChecked: false }
            : ele
        );
      } else {
        selectedJourneys = card.map((ele, id) =>
          id == name
            ? { ...ele, isChecked: checked }
            : ele && card[1].isChecked && id == 0 && !props?.isChangeBooking
            ? { ...ele, isChecked: false }
            : ele
        );
        name == 1 && card[name]?.isChecked == true ? setDisabled(false) : setDisabled(true);
      }
      setCard(selectedJourneys);
    }
    selectedJourneys = selectedJourneys.filter((data: { isChecked: boolean }) => data?.isChecked === true);
    dispatch(setSelectedJourneys(selectedJourneys));

    if (props?.isChangeBooking && selectedJourneys?.length > 0) {
      setOrigin(
        airports?.filter(
          (airport: { stationCode: string }) =>
            airport?.stationCode === selectedJourneys?.[0]?.journeyDetails?.designator?.origin
        )?.[0]
      );
      setDestination(
        airports?.filter(
          (airport: { stationCode: string }) =>
            airport?.stationCode === selectedJourneys?.[0]?.journeyDetails?.designator?.destination
        )?.[0]
      );
    }
  };

  const getMinDateForChangeBooking = (id: number) => {
    if(props.isChangeBooking && id === 1) {
      return firstJourneyDate
    } 
    return new Date()
  }

  useEffect(() => {
    const secondJourneyDateTimestamp = Math.floor(secondJourneyDate.getTime() / (3600 * 1000 * 24));
    const firstJourneyDateTimestamp = Math.floor(firstJourneyDate.getTime() / (3600 * 1000 * 24));
    const isChangeInvalid = secondJourneyDateTimestamp < firstJourneyDateTimestamp;
    props.isCheckDateChangeInValid?.(isChangeInvalid);
  }, [firstJourneyDate, props, secondJourneyDate])

  const updateSelectedJourneys = (newValue, id) => {
    const localDate = new Date(newValue);
    const utcDate = new Date(Date.UTC(localDate.getFullYear(), localDate.getMonth(), localDate.getDate()))
    if(id === 0) {
      setFirstJourneyDate(utcDate)
    }
    if(id === 1) {
      setSecondJourneyDate(utcDate)
    }
    let selectedJourneys = card.map((ele, k) => ({
      ...ele,
      newBookingDate: k === id ? newValue : ele?.newBookingDate
    }));
    setCard(selectedJourneys);
    selectedJourneys = selectedJourneys.filter((data: { isChecked: boolean }) => data.isChecked === true);
    dispatch(setSelectedJourneys(selectedJourneys));
  };

  useEffect(() => {
    if (props?.isChangeBooking && card?.length === 1) {
      updateSelectedJourneys(departureDate, 0);
    }
  }, [departureDate]);

  return (
    <>
      {props?.journeys?.length > 1 &&
      (!props?.isChangeBooking || !props?.journeys?.[0]?.journeyDetails?.wasAnyCheckInDone) ? (
        <div id="selectAllSection" className="flex justify-between items-center ml-1">
          <p className="font-medium text-typography-primary">{extractResource(resourceData, "selectAll")}</p>
          <CustomSwitch
            className={cssStyle.customSwitch}
            onChange={toggle}
            checked={card.filter((ele) => isAnyPaxUnchecked(ele.journeyDetails) && ele?.isChecked !== true).length < 1}
            disabled={card.filter((ele) => ele?.data?.checkinByJourneyRequirements?.restrictions == null)?.length < 2}
            name="allSelect"
            {...label}
            color="primary"
          />
        </div>
      ) : null}
      {card.map((ele: { journeyDetails: JourneyDetails; isChecked: boolean }, id: number) => {
        let isPreviousFlight = false;
        if (moment(ele?.journeyDetails?.designator?.departure) < moment()) {
          isPreviousFlight = true;
        }
        const isAllApproved = ele.journeyDetails.segments[0].passengerSegment
          .map((passenger) => passenger.liftStatus === "CheckedIn" || passenger.liftStatus === "Boarded")
          .every((status) => status);

        if (isAllApproved) {
          return <div key={id} />;
        }
        return (
          <div aria-label="flight-schedule" key={id}>
            <FCal key={id}>
              <CheckinJourneySelectionCard
                journeyDetailsInfo={ele}
                airports={airports}
                passengerSegment={passengerSegment}
                resourceData={resourceData}
                isChangeBooking={props?.isChangeBooking}
                journeys={props?.journeys}
                toggle={toggle}
                id={id}
                isPreviousFlight={isPreviousFlight}
              />
            </FCal>
            {!props?.isChangeBooking || ele?.journeyDetails?.wasAnyCheckInDone || !ele?.isChecked ? null : (
              <Box className="datepicker" sx={{ mt: 2 }}>
                {card?.length === 1 ? (
                  <PricingCalendarV2
                    label={extractResource(resourceData, "preferredDate")}
                    selectedOptionOrg={origin?.stationCode}
                    selectedOptionDest={destination?.stationCode}
                    selectedDate={departureDate}
                    onChange={(newValue) => {
                      updateSelectedJourneys(moment(newValue).format("YYYY/MM/DD"), id);
                    }}
                    minDate={String(new Date())}
                    selectedCurrency={selectedCurrency}
                  />
                ) : (
                  <PricingCalendarV2
                    label={extractResource(resourceData, "preferredDate")}
                    selectedOptionOrg={ele?.journeyDetails?.designator?.origin}
                    selectedOptionDest={ele?.journeyDetails?.designator?.destination}
                    selectedDate={ele?.newBookingDate}
                    onChange={(newValue) => {
                      updateSelectedJourneys(moment(newValue).format("YYYY/MM/DD"), id);
                    }}
                    minDate={String(getMinDateForChangeBooking(id))}
                    selectedCurrency={selectedCurrency}
                  />
                )}
              </Box>
            )}
          </div>
        );
      })}
    </>
  );
}
export default Calendar;
